import React, { useState } from 'react';
import { Flex, Modal } from '@landr/maestro';
import { useActivateTrialSubscription } from 'apollo/user';
import { ModalProps } from 'modals/Modal.types';
import { usePurchaseControllerContext } from 'contexts/PurchaseControllerContext/PurchaseControllerContext';
import { useStoreAttemptedDownloadAction } from 'hooks/useStoreAttemptedDownloadAction';
import { attemptedActionStore } from 'helpers/attemptedActionStore';
import { useSubscriptionsAndAllowedFeaturesContext } from 'contexts/SubscriptionsAndAllowedFeaturesContext/SubscriptionsAndAllowedFeaturesContext';
import { EventIds } from '../../constants';
import { log } from '../../utils/log';
import { ActivateTrialSubscriptionModalContent } from './ActivateTrialSubscriptionModalContent';

const ActivateTrialSubscriptionModal: React.FC<ModalProps> = ({
    isOpen,
    handleClose,
}) => {
    const [isConfirmationLoading, setIsConfirmationLoading] = useState(false);
    const { cancelPurchase, item: downloadableItem } =
        usePurchaseControllerContext();
    const { activateTrialSubscription, loading, error, data } =
        useActivateTrialSubscription();
    const { unallowedByPlan } = useSubscriptionsAndAllowedFeaturesContext();

    useStoreAttemptedDownloadAction(downloadableItem, isOpen);

    const handleActivateNow = async () => {
        await activateTrialSubscription().catch((error) => {
            log.error(
                'Error activating trial subscription',
                EventIds.ActivateTrialSubscriptionError,
                error,
            );
        });
    };

    const handleCloseModal = () => {
        cancelPurchase();
        if (data) {
            setIsConfirmationLoading(true);
            // reload to get the activated subscription credits and states.
            // add a timeout so we leave enough time for the process to be completed in the BE.
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else {
            attemptedActionStore.remove();
            handleClose();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleCloseModal}
            size="sm"
            isDismissible={!loading}
        >
            <Modal.Header />
            <Modal.Content>
                <Modal.Section pt={0}>
                    <Flex
                        flexDirection="column"
                        alignItems="center"
                        textAlign="center"
                        sx={{ gap: 'sm' }}
                    >
                        <ActivateTrialSubscriptionModalContent
                            loading={loading || isConfirmationLoading}
                            error={error}
                            data={data}
                            onClose={handleCloseModal}
                            onActivateNow={handleActivateNow}
                            trialPlanCode={unallowedByPlan as string}
                        />
                    </Flex>
                </Modal.Section>
                <Modal.Footer />
            </Modal.Content>
        </Modal>
    );
};

export default ActivateTrialSubscriptionModal;
